import { createSelector } from '@ngrx/store';
import { getOnlineMenuPagesFiltered } from '../getOnlineMenuPagesFiltered';

export const getOnlineMenuProductsFiltered = createSelector(
    getOnlineMenuPagesFiltered,
    (onlineMenuPagesFiltered) => onlineMenuPagesFiltered?.reduce((products, page) => [...products, ...page.Products], [] as OLO.DTO.OnlineMenuProductResponseModel[]) || null,
);
